module.exports = require('./bundle-legacy.js')
